import { Injectable } from '@angular/core';
import {
  IShoppingProducts,
  IMoreProductsResponse,
  ITotalProductsResponse,
  IProductUpdatedResponse,
  ShopAgain,
  IShoppingProductsDeliveryAndTax,
  IValidateLabel,
  SendTypeCart,
  SaveProductUtility,
  DeleteTypeCart,
  IValidateMagistralProducts,
} from '../model/http/shoppingList';
import { Endpoints } from '../../environments/endpoints';
import { Observable, of } from 'rxjs';
import {
  ChangeProductQuantityOrdersResponse,
  ShopingCartUpdatedPricesResponse,
  UpdateProduct,
  UpdateProductUtility,
} from 'src/app/model/local/shopping-cart';
import { BaseResponseHttp } from 'src/app/model/http/commons.model';
import { DeleteProduct } from '../model/local/shopping-cart';
import { ConsumeService } from './consume.service';
import { IGeneralResponse } from '../model/http/general-response.model';
import { ResponseRestoreCart, RestoreCart } from '../model/http/myActivity.model';
import { SpinnerNames } from '../constants/spinners';
import { MissingPTResponse } from 'src/mocks/missingpt.mock';
import { CarTicksResponse, IGetCalculateShippingCost } from '../model/http/shippingCost';
import { CreditNotesResponse } from '../model/http/favorBalance.model';
import { BBVAOrderDetailResponse } from '../model/http/bbva.model';
import { BBVADetailOrderResponseMock } from 'src/mocks/bbvaMocks';
import { ShoppingCarTicks } from 'src/mocks/shoppingCartMock';
import { CatalogField, CatalogFieldResponse } from '../model/http/catalogs';
@Injectable({
  providedIn: 'root',
})
export class ShoppingCartService {
  constructor(private comsumeService: ConsumeService) { }
  getShoppingList(queryParams: string): Observable<IShoppingProducts> {
    return this.comsumeService.httpGet<IShoppingProducts>(
      `${Endpoints.shoppingCart.shoppingCart}${queryParams}`, null, null, SpinnerNames.generalList
    );
  }

  updateProduct(product: UpdateProduct): Observable<IProductUpdatedResponse> {
    return this.comsumeService.httpPut<IProductUpdatedResponse>(
      `${Endpoints.shoppingCart.shoppingCart}`,
      [product]
    );
  }

  updateProductList(products: UpdateProduct[]): Observable<IProductUpdatedResponse> {
    return this.comsumeService.httpPut<IProductUpdatedResponse>(
      `${Endpoints.shoppingCart.shoppingCart}`, products
    );
  }


  deleteProductService(product: DeleteProduct): Observable<BaseResponseHttp> {
    return this.comsumeService.httpPost(
      `${Endpoints.shoppingCart.shoppingCart}`,
      product
    );
  }

  checkMoreProducts(queryParams: string): Observable<IMoreProductsResponse> {
    return this.comsumeService.httpGet<IMoreProductsResponse>(
      `${Endpoints.shoppingCart.checkMoreProducts}${queryParams}`
    );
  }

  getTotalPieces(cardCode: string, cartList: number[]): Observable<ITotalProductsResponse> {
    return this.comsumeService.httpPost<ITotalProductsResponse>
      (`${Endpoints.shoppingCart.shoppingCartBase}/total/${cardCode}/count`, cartList);
  }

  submitShopAgain(shop: ShopAgain): Observable<IGeneralResponse> {
    return this.comsumeService.httpPost<IGeneralResponse>(
      `${Endpoints.shoppingCart.ShopAgain}`,
      shop
    );
  }

  getDeliveryAndTax(
    queryParams: string
  ): Observable<IShoppingProductsDeliveryAndTax> {
    return this.comsumeService.httpGet<IShoppingProductsDeliveryAndTax>(
      `${Endpoints.shoppingCart.deliveryAndTax}${queryParams}`
    );
  }

  updateProductUtilities(
    product: UpdateProductUtility,
    cardCode: string
  ): Observable<IShoppingProducts> {
    return this.comsumeService.httpPost<IShoppingProducts>(
      `${Endpoints.shoppingCart.updateProductUtilities}${cardCode}/products`,
      [product]
    );
  }

  getValidateLabel(queryParams: string): Observable<IValidateLabel> {
    return this.comsumeService.httpGet<IValidateLabel>(
      `${Endpoints.shoppingCart.validateLabel}${queryParams}`
    );
  }

  saveOneProductInSavedCart(query: SendTypeCart): Observable<BaseResponseHttp> {
    return this.comsumeService.httpPost(
      `${Endpoints.shoppingCart.saveOneProductToSavedCart}`,
      query
    );
  }

  saveAllProductsInCart(query: SendTypeCart): Observable<BaseResponseHttp> {
    return this.comsumeService.httpPost(
      `${Endpoints.shoppingCart.saveAllShoppingCart}`,
      query
    );
  }

  deleteAllProductsInCart(query: DeleteTypeCart): Observable<BaseResponseHttp> {
    return this.comsumeService.httpPost(
      `${Endpoints.shoppingCart.deleteAllShoppingCart}`,
      query
    );
  }

  restoreCartSaved(queryParams: RestoreCart): Observable<ResponseRestoreCart> {
    return this.comsumeService.httpGet<ResponseRestoreCart>(`${Endpoints.myProducts.restoreCartSaved}?cardCode=${queryParams.cardCode}&typecart=${queryParams.typecart}` +
      `&priceListId=${queryParams.priceListId}&clientType=${queryParams.clientType}`
    );
  }

  saveUtilitiesProducts(req: SaveProductUtility): Observable<BaseResponseHttp> {
    return this.comsumeService.httpPost(Endpoints.shoppingCart.saveUtilityProducts, req);
  }

  updateOrderQuantities(transactionId: string, products: UpdateProduct[]): Observable<ChangeProductQuantityOrdersResponse> {
    return this.comsumeService.httpPut(`${Endpoints.updateOrdersQuantity.updatePieces}${transactionId}`, products);
  }

  updateShoppingCartPrices(params: string): Observable<ShopingCartUpdatedPricesResponse> {
    return this.comsumeService.httpGet(`${Endpoints.shoppingCart.updatePrices}${params}`);
  }

  getCalculateShippingCost(params: string): Observable<IGetCalculateShippingCost> {
    return this.comsumeService.httpGet(`${Endpoints.shoppingCart.getDefaultDirectionCost}${params}`);
  }
  getCreditNotes(cardCode: string): Observable<CreditNotesResponse> {
    return this.comsumeService.httpGet(`${Endpoints.shoppingCart.creditNotes}/${cardCode}/open`);
  }

  getBBVAPaymentDetailInfo(transaction: string): Observable<BBVAOrderDetailResponse> {
    return this.comsumeService.httpGet(`${Endpoints.bbva.getOrderDetail}?transactionId=${transaction}`);
  }

  getCarTicks(cardCode: string, typeCart: number): Observable<CarTicksResponse> {
    return this.comsumeService.httpGet(`${Endpoints.shoppingCart.getTicks}/${cardCode}/${typeCart}/ticks`);
  }
  getShowPromotionalCodeMessage(): Observable<CatalogFieldResponse> {
    return this.comsumeService.httpGet(Endpoints.shoppingCart.ShowPromotionalCodeMessage);
  }

  validateMagistralProducts(params: string): Observable<IValidateMagistralProducts> {
    return this.comsumeService.httpGet(`${Endpoints.shoppingCart.validateMagistralProductsInCart}?${params}`);
  }
}
